import "./DynamicDownloadBtnSection.scss";
import Lines from "../Lines";
import DownloadBtn from "../../Academics/AcademicCalendar/DownloadBtn";

const DynamicDownloadBtnSection = ({ title, items = [], btnName, titleFontSize, yearFontSize }) => {

   
    return (
        <section className="dynamic-sections-container">
            {title && (
                <div style={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
                    <h2 className="dynamic-sections-title">{title}</h2>
                </div>
            )}

            {items.length === 1 ? (
                <div className="dynamic-section single-button">
                    <DownloadBtn
                        year={items[0].filename}
                        fileData={items[0].data}
                        contentType={items[0].contentType}
                        btnName={btnName}
                        titleFontSize={titleFontSize}
                        yearFontSize={yearFontSize}
                    />
                </div>
            ) : (
                items.map((year, index) => {
                    if (index % 2 === 0) {
                        if (index === items.length - 1) {
                            return (
                                <div className="dynamic-section single-button" key={index}>
                                    <DownloadBtn
                                        year={year.filename}
                                        fileData={year.data}
                                        contentType={year.contentType}
                                        btnName={btnName}
                                        titleFontSize={titleFontSize}
                                        yearFontSize={yearFontSize}
                                    />
                                </div>
                            );
                        }

                        return (
                            <div className="dynamic-section" key={index}>
                                <DownloadBtn
                                    year={year.filename}
                                    fileData={year.data}
                                    contentType={year.contentType}
                                    btnName={btnName}
                                    titleFontSize={titleFontSize}
                                    yearFontSize={yearFontSize}
                                />
                                <div className="lines-parent">
                                    <Lines count={10} color="white" fontSize={2} spacing={0.3} thickness={700} skewParent={-40} />
                                </div>
                                {items[index + 1] && (
                                    <DownloadBtn
                                        year={items[index + 1].filename}
                                        fileData={items[index + 1].data}
                                        contentType={items[index + 1].contentType}
                                        btnName={btnName}
                                        titleFontSize={titleFontSize}
                                        yearFontSize={yearFontSize}
                                    />
                                )}
                            </div>
                        );
                    }
                    return null;
                })
            )}
        </section>
    );
};

export default DynamicDownloadBtnSection;
